export interface FieldRepresentativePreset {
  name: string;
  residentNumber: string;
  maskedResidentNumber: string;
  address: string;
  birthDate: string;
  year: string;
  period: string;
  position: string;
  category: string;
  grade: string;
  registrationNumber: string;
  registrationDate: string;
  companyId?: string;
}

export interface CompanyInfoPreset {
  businessNumber: string;
  corporateNumber: string;
  companyName: string;
  address: string;
  detailAddress: string;
  representative: string;
  phone: string;
  fax: string;
  accountNumber: string;
  depositType: string;
  accountHolder: string;
  bankName: string;
  branchName: string;
}

export interface ProjectInfoPreset {
  projectName: string;
  projectLocation: string;
  contractDate: string;
  startDate: string;
  completionDate: string;
  projectPeriod: string;
  performancePeriod: string;
  expectedCompletionDate: string;
  contractAmount: string;
  contractDeposit: string;
  warrantyPeriod: string;
  client: string;
  businessType: string;
  defectWarrantyPeriod: string;
  cityInfo: string;
  orderingOrganization: string;
  completionSettlementAmount: string;
  claimDate: string;
  claimAmount: string;
  companyId?: string;
}

// 개별 타입별 프리셋
export interface PresetItem {
  id: string;
  name: string;
  type: "fieldRepresentative" | "companyInfo" | "projectInfo";
  data: FieldRepresentativePreset | CompanyInfoPreset | ProjectInfoPreset;
  createdAt: string;
}

export const PRESET_TYPES = {
  companyInfo: {
    label: "회사정보",
    icon: "business",
    fields: [
      {
        key: "businessNumber",
        label: "사업자등록번호",
        type: "text",
        required: true,
      },
      {
        key: "corporateNumber",
        label: "법인번호",
        type: "text",
        required: false,
      },
      { key: "companyName", label: "상호", type: "text", required: true },
      { key: "address", label: "주소", type: "text", required: true },
      {
        key: "detailAddress",
        label: "상세주소",
        type: "text",
        required: false,
      },
      { key: "representative", label: "대표자", type: "text", required: false },
      { key: "phone", label: "회사전화", type: "tel", required: false },
      { key: "fax", label: "회사팩스", type: "tel", required: false },
      {
        key: "accountNumber",
        label: "계좌번호",
        type: "text",
        required: false,
      },
      {
        key: "depositType",
        label: "예금종류",
        type: "text",
        required: false,
      },
      {
        key: "accountHolder",
        label: "예금주",
        type: "text",
        required: false,
      },
      {
        key: "bankName",
        label: "은행명",
        type: "text",
        required: false,
      },
      {
        key: "branchName",
        label: "점포명",
        type: "text",
        required: false,
      },
    ],
  },
  fieldRepresentative: {
    label: "현장대리인",
    icon: "person",
    fields: [
      { key: "name", label: "성명", type: "text", required: true },
      {
        key: "residentNumber",
        label: "주민등록번호",
        type: "text",
        required: false,
      },
      { key: "address", label: "주소", type: "text", required: true },
      { key: "birthDate", label: "생년월일", type: "date", required: false },
      {
        key: "year",
        label: "자격증 취득/갱신일자",
        type: "date",
        required: false,
      },
      { key: "period", label: "재직기간", type: "text", required: false },
      { key: "position", label: "직위", type: "text", required: false },
      { key: "category", label: "자격종목", type: "text", required: false },
      { key: "grade", label: "등급", type: "text", required: false },
      {
        key: "registrationNumber",
        label: "자격증등록번호",
        type: "text",
        required: false,
      },
      {
        key: "registrationDate",
        label: "등록일자",
        type: "date",
        required: false,
      },
    ],
  },
  projectInfo: {
    label: "공사정보",
    icon: "construction",
    fields: [
      { key: "projectName", label: "공사명", type: "text", required: true },
      {
        key: "projectLocation",
        label: "공사위치",
        type: "text",
        required: true,
      },
      { key: "contractDate", label: "계약일자", type: "date", required: false },
      { key: "startDate", label: "착공일자", type: "date", required: false },
      {
        key: "completionDate",
        label: "준공일자",
        type: "date",
        required: false,
      },
      {
        key: "projectPeriod",
        label: "공사기간",
        type: "text",
        required: false,
      },
      {
        key: "performancePeriod",
        label: "공사이행기간",
        type: "text",
        required: false,
      },
      {
        key: "expectedCompletionDate",
        label: "준공예정년월일",
        type: "date",
        required: false,
      },
      {
        key: "contractAmount",
        label: "계약금액",
        type: "text",
        required: false,
      },
      {
        key: "contractDeposit",
        label: "계약보증금",
        type: "text",
        required: false,
      },
      {
        key: "warrantyPeriod",
        label: "보증기간",
        type: "text",
        required: false,
      },
      { key: "client", label: "계약부서정보", type: "text", required: false },
      { key: "businessType", label: "면허정보", type: "text", required: false },
      {
        key: "defectWarrantyPeriod",
        label: "하자보증기간",
        type: "text",
        required: false,
      },
      {
        key: "cityInfo",
        label: "지역소속시",
        type: "text",
        required: false,
      },
      {
        key: "orderingOrganization",
        label: "발주처정보",
        type: "text",
        required: false,
      },
    ],
  },
} as const;
